import { APP_PATHS } from './app-paths'
import { getEnvironmentKey } from './environment'
import { EVENT_SEGMENTS } from './eventSegments'
// The server redirects read this file too, so it is JSON.
import templeEventIds from './templeEventIds.json'

export const TEMPLE_PATH = APP_PATHS.temple
export const TEMPLE_FRIEND_PATH = `${TEMPLE_PATH}/${EVENT_SEGMENTS.friend}/:socialInviteId`

// Matches a whole segment, so a path such as /temples is not a Temple path.
export const isTemplePath = (pathname: string): boolean =>
  pathname === TEMPLE_PATH || pathname.startsWith(`${TEMPLE_PATH}/`)

/** Temple routes carry no event id in the path, so they get the id from the environment. */
export const resolveEventId = (pathEventId: string | undefined, onTemplePath: boolean): string | undefined =>
  pathEventId ?? (onTemplePath ? getTempleEventId() : undefined)

// An empty id turns off the Temple event routes, the server redirects, and the feedback button.
// Production has no id yet.
export function getTempleEventId(): string | undefined {
  return templeEventIds[getEnvironmentKey()] || undefined
}
